import { render, staticRenderFns } from "./Descriptions.html?vue&type=template&id=2aa8b45c&scoped=true&"
import script from "./Descriptions.vue?vue&type=script&lang=js&"
export * from "./Descriptions.vue?vue&type=script&lang=js&"
import style0 from "./Descriptions.vue?vue&type=style&index=0&id=2aa8b45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8b45c",
  null
  
)

export default component.exports